import { FocusEvent, memo, ReactNode, useCallback } from "react";
import classNames from "classnames";
import { NumberField, NumberFieldProps } from "../NumberField";

import styles from "./style.module.scss";

export type FinancialFieldProps = NumberFieldProps & {
  currencySymbol?: ReactNode
};

export const FinancialField = memo<FinancialFieldProps>(
  (
    {
      className,
      onFocus,
      precision = 2,
      placeholder = "XX.XX",
      isClearable = false,
      rootContainerProps,
      currencySymbol = "$",
      startAdornment,
      ...props
    }) => {
    return (
      <NumberField
        rootContainerProps={{
          ...rootContainerProps,
          className: classNames(rootContainerProps?.className, styles.root),
        }}
        onFocus={useCallback((e: FocusEvent<HTMLInputElement>) => {
          onFocus?.(e);
          if (!e.defaultPrevented) {
            const input = e.target;
            input.select();
          }
        }, [ onFocus ])}
        hideErrorIcon
        precision={precision}
        placeholder={placeholder}
        isClearable={isClearable}
        startAdornment={
          <>
            {currencySymbol && <span>{currencySymbol}</span>}
            {startAdornment}
          </>
        }
        {...props}
      />
    );
  },
);